exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ew-logo-small{bottom:0;position:absolute}.pageLinks{color:#fff;text-decoration:none}#titleList{position:absolute;top:50%;transform:translateY(-50%)}#titleList .list__tile{height:50px!important}#titleList .list__tile__title{height:100%!important;line-height:normal!important}.mobileStyle{font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif;font-weight:lighter;font-size:2em}.roundCard{border-radius:35px}.dialog{border-radius:35px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cdedc3e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 483
// module chunks = 0